module.exports = __webpack_public_path__ + "img/vue3-web3-6.a76ec70c.jpg";